"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionStatusMap = exports.CommissionStatusCodeMap = exports.CommissionStatusType = exports.CommissionStatusCodes = void 0;
var CommissionStatusCodes;
(function (CommissionStatusCodes) {
    CommissionStatusCodes[CommissionStatusCodes["STATUS_DELETED"] = -2] = "STATUS_DELETED";
    CommissionStatusCodes[CommissionStatusCodes["STATUS_CREATED"] = -1] = "STATUS_CREATED";
    CommissionStatusCodes[CommissionStatusCodes["STATUS_ACTIVE"] = 1] = "STATUS_ACTIVE";
})(CommissionStatusCodes = exports.CommissionStatusCodes || (exports.CommissionStatusCodes = {}));
var CommissionStatusType;
(function (CommissionStatusType) {
    CommissionStatusType["ACTIVE"] = "active";
    CommissionStatusType["DISABLED"] = "disabled";
})(CommissionStatusType = exports.CommissionStatusType || (exports.CommissionStatusType = {}));
exports.CommissionStatusCodeMap = (_a = {},
    _a[CommissionStatusType.ACTIVE] = CommissionStatusCodes.STATUS_ACTIVE,
    _a[CommissionStatusType.DISABLED] = CommissionStatusCodes.STATUS_CREATED,
    _a);
exports.CommissionStatusMap = (_b = {},
    _b[CommissionStatusCodes.STATUS_ACTIVE] = CommissionStatusType.ACTIVE,
    _b[CommissionStatusCodes.STATUS_CREATED] = CommissionStatusType.DISABLED,
    _b);
//# sourceMappingURL=commissions.js.map